<template>
    <div>
        <budgets-rollover-list @updated="refreshAll" :employer_id="data.employer_id"></budgets-rollover-list>

        <h2>Budget Spend</h2>
        <ebudgets-drilldown :employer_id="data.employer_id" :refreshIndex="refreshIndex"></ebudgets-drilldown>

        <h2 style="margin-top: 50px;">Campaigns</h2>
        <side-by-side @updated="refreshBudget" :employer_id="data.employer_id" :refreshIndex="refreshCampaignsIndex"></side-by-side>
        <employer-notes-wrapper :employer-id="employerId" />
    </div>
</template>

<script>
import EbudgetsDrilldown from "./drilldown/ebudgets-00-drilldown";
import BudgetCampaign from "./dialogs/budget-campaign";
import Billing from "../../BudgetPeriod/vue/dialogs/billing";
import BudgetsRolloverList from "../../BudgetRollover/vue/budgets-rollover-list";
import SideBySide from "./budget-order/side-by-side";

export default {
    components: {
        SideBySide,
        BudgetsRolloverList,
        Billing, BudgetCampaign, EbudgetsDrilldown},
    props: [
        'data',
        'employerId',
    ],
    data() {
        return {
            show_dialogs: {
                campaign: false,
                billing: false
            },
            refreshIndex: 0,
            refreshCampaignsIndex: 0
        };
    },
    methods: {
        refreshBudget() {
            this.refreshIndex++;
        },
        refreshAll() {
            this.refreshCampaignsIndex++;
            this.refreshIndex++;
        }
    }
}
</script>

<style>
.table-separator {
    border-left: solid 2px #eee;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
